import {getCardTypeWithPrefix} from '../utils/getCardTypeBasedOnPrefix';

export const isCardTypeValidForChunking = (cardNumber) => {
  const cardType = getCardTypeWithPrefix(cardNumber);
  return (cardType === 'visa-electron' || cardType === 'visa-credit' || cardType === 'mastercard' || cardType === 'amex');
}